import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
const LoadingDataGridRowOverlay = ({ rowElement }) => {
	if (!rowElement) return null;

	const rect = rowElement.getBoundingClientRect();
	const tableRect = rowElement.closest('.MuiDataGrid-root').getBoundingClientRect();
	const top = rect.bottom - tableRect.top;

	return (
		<Box
			sx={{
				position: 'absolute',
				top,
				left: 0,
				width: '100%',
				height: '2px',
				backgroundColor: 'transparent',
				zIndex: (theme) => theme.zIndex.tooltip,
			}}
		>
			<LinearProgress />
		</Box>
	);
};

export default LoadingDataGridRowOverlay;
